module.exports = __webpack_public_path__ + "img/icon_5_46.5ce7de30.png";